import React, { useEffect, useState } from "react";
import { Grid, Typography, Divider, Box } from "@mui/material";

import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";

const SalesMethodReport = ({ fromDate, toDate }) => {
  const { store } = useStateContext();

  const [data, setData] = useState();

  useEffect(() => {
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g,"");
    const databaseStoreName = `DB301_${JSON.parse(store).id}_${correctStoreName}`;

    const payload = {
      shopName: databaseStoreName,
      from: fromDate,
      to: toDate,
    };
    axiosClient
      .post("reports/sales/salesmethod", payload)
      .then((response) => setData(response.data.data))
      .catch((err) => console.log(err));
  }, [store, fromDate, toDate]);

  const formatDate = (dateString) => {
    const parts = dateString.split('-');
    if (parts.length === 3) {
        const [year, month, day] = parts;
        return `${day}/${month}/${year}`;
    } else {
        return 'Invalid Date';
    }
}

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="inherit">Sales by sales method</Typography>
        <Typography variant="caption">{` ${formatDate(fromDate)} - ${formatDate(toDate)}`}</Typography>
        <Divider />
      </Grid>
      <Grid item container xs={12}>
        <Grid item xs={4}>
          <Typography variant="body1" style={{fontWeight: 700}} align="center">Sales method</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body1" style={{fontWeight: 700}} align="center">Total Gross Value</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body1" style={{fontWeight: 700}} align="center">Total Net Value</Typography>
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <Divider />
          </Box>
        </Grid>
      </Grid>
      {data.map((salesmethod, index) => (
        <Grid item container xs={12} key={index+1}>
          <Grid item xs={4}>
            <Typography variant="body2" align="center">{salesmethod.sales_method}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" align="center">{parseFloat(salesmethod.totalGrossValue).toFixed(2)}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" align="center">{parseFloat(salesmethod.totalNetValue).toFixed(2)}</Typography>
          </Grid>
          <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <Divider />
          </Box>
        </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default SalesMethodReport;
